import { useLocation, useParams } from 'react-router-dom'
import MainLayout from '../../components/Layout'
import SaddleForm from './SaddleForm'
import SaddleView from './SaddleView'

function SaddleFormPage() {
  const location = useLocation()
  const { encodedId } = useParams()
  const isEditMode = !!encodedId

  return (
    <MainLayout>
      <div className="w-full flex flex-col items-center  mb-5 sm:mb-0 h-auto">
        <h1 className="admin-dashboard">
          {location.state?.isViewMode ? 'Saddle Details' : isEditMode ? 'Update Saddle' : 'Create New Saddle'}
        </h1>
        {location.state?.isViewMode ? <SaddleView /> : <SaddleForm />}
      </div>
    </MainLayout>
  )
}

export default SaddleFormPage
